
import React from 'react';
import { Link } from 'react-router-dom';

const SidebarLeftOne = () => {
    return(
        <>
        <div className="col-md-4 order-md-1">
			<div className="widget widget-search">
			<form className="side-form">
				<input type="text" className="form-control input-style-one" placeholder="Search Here..." />
				<button type="submit">
				<i className="fa fa-paper-plane" />
				</button>
			</form>
			</div>
			<div className="widget widget-categories">
			<div className="all-title">
				<h3>
				<span>Categories</span>
				</h3>
			</div>
			<div className="widget-items">
				<ul>
				<li className="blog-category">
					<Link to="#">Property Law</Link>
				</li>
				<li className="blog-category">
					<Link to="#">Finance &amp; Security Law</Link>
				</li>
				<li className="blog-category">
					<Link to="#">Corporate Law</Link>
				</li>
				<li className="blog-category">
					<Link to="#">Criminal Defence Law</Link>
				</li>
				<li className="blog-category">
					<Link to="#">Serious Car Crash</Link>
				</li>
				<li className="blog-category">
					<Link to="#">Child Labor</Link>
				</li>
				<li className="blog-category">
					<Link to="#">Justice Fight</Link>
				</li>
				<li className="blog-category">
					<Link to="#">Family Law</Link>
				</li>
				</ul>
			</div>
			</div>
			<div className="widget widget-recent-post">
			<div className="all-title">
				<h3>
				<span>Recent Post</span>
				</h3>
			</div>
			<div className="widget-items">
				<ul>
				<li>
					<div className="blog-rp-image">
					<Link to="single-post-left-sidebar.html">
						<img src="images/blog/bl-01-120x120.png" alt="thumb" />
					</Link>
					</div>
					<div className="blog-rp-info">
					<p><Link to="single-post-left-sidebar.html">All you want to know about law</Link></p>
					<p>Lorem ipsum dolor sit amet, cohy elitr</p>
					</div>
				</li>
				<li>
					<div className="blog-rp-image">
					<Link to="single-post-left-sidebar.html">
						<img src="images/blog/bl-01-120x120.png" alt="thumb" />
					</Link>
					</div>
					<div className="blog-rp-info">
					<p><Link to="single-post-left-sidebar.html">All you want to know about law</Link></p>
					<p>Lorem ipsum dolor sit amet, cohy elitr</p>
					</div>
				</li>
				<li>
					<div className="blog-rp-image">
					<Link to="single-post-left-sidebar.html">
						<img src="images/blog/bl-01-120x120.png" alt="thumb" />
					</Link>
					</div>
					<div className="blog-rp-info">
					<p><Link to="single-post-left-sidebar.html">All you want to know about law</Link></p>
					<p>Lorem ipsum dolor sit amet, cohy elitr</p>
					</div>
				</li>
				<li>
					<div className="blog-rp-image">
					<Link to="single-post-left-sidebar.html">
						<img src="images/blog/bl-01-120x120.png" alt="thumb" />
					</Link>
					</div>
					<div className="blog-rp-info">
					<p><Link to="single-post-left-sidebar.html">All you want to know about law</Link></p>
					<p>Lorem ipsum dolor sit amet, cohy elitr</p>
					</div>
				</li>
				</ul>
			</div>
			</div>
			<div className="widget widget-archives">
			<div className="all-title">
				<h3>
				<span>archives</span>
				</h3>
			</div>
			<div className="widget-items widget-archie">
				<ul>
				<li>
					<Link to="#">july
					<span>20</span>
					</Link>
				</li>
				<li>
					<Link to="#">November
					<span>36</span>
					</Link>
				</li>
				<li>
					<Link to="#">october
					<span>12</span>
					</Link>
				</li>
				</ul>
			</div>
			</div>
		</div>
        </>
    )
}

export default SidebarLeftOne;